/**
 * Is this a name a person gave something, or one a camera did?
 *
 * A garment uploaded from a phone arrives called `71FAD406-4672-468C-96F4-
 * 6F5D5F5820EC.jpeg` or `IMG_4821.HEIC`, and the wardrobe used to take the
 * filename as the garment's name. So the stream offered to "Photographier
 * 71FAD406 4672 468C 96F4 6F5D5F5820EC sur Delphine" — a sentence built to be
 * pressed, naming a piece by the one thing about it nobody knows.
 *
 * Deliberately narrow: it has to recognise what cameras, phones and screenshot
 * tools write, and nothing a person would type. A false positive only costs a
 * suggestion its garment; a false negative puts a hash in front of someone.
 */
export function looksMachineMade(name: string | undefined): boolean {
  const text = (name ?? '').trim();
  if (!text) return true;

  const squeezed = text.replace(/[\s_.-]+/g, '');
  // A UUID, or any long run of hex: what iOS calls an exported photograph.
  if (/^[0-9a-f]{16,}$/i.test(squeezed)) return true;
  // Nothing but digits: a timestamp, or a counter.
  if (/^\d+$/.test(squeezed)) return true;

  // A camera's, phone's or screenshot tool's prefix, then its counter or date.
  return /^(img|dsc[nf]?|pxl|mvimg|vid|photo|image|pic|scan|screenshot|screen shot|capture d.?[ée]cran|capture|whatsapp image|signal)[\s_-]*\d/i.test(
    text,
  );
}
